import { app, ojs, Component } from "modular-openscriptjs";
import { dom } from "../../../fotastart";
import InfiniteScroll from "../../Blocks/InfiniteScroll";
import Spinner from "../../Blocks/Spinner";
import SuggestedUserView from "./SuggestedUserView";
import SuggestedUsersCanvas from "./SuggestedUsersCanvas";
import { api, dc, gc } from "../../../declarations";
import { $e } from "../../../ojs.events";
import { routes } from "../../../backendRoutes";

const h = app("h");
const broker = app("broker");

ojs(InfiniteScroll, Spinner, SuggestedUserView, SuggestedUsersCanvas);

export default class SuggestedUsers extends Component {
	pageMap = null;

	initMap() {
		if (this.pageMap == null) this.pageMap = { users: 0, businesses: 0 };
	}

	render(config, ...args) {
		this.initMap();

		let type = config?.type ?? "user";
		let filter = config?.filter ?? "filter";

		let attributes = config?.attributes ?? {
			class: "d-flex flex-row overflow-auto gap-3 p-1 pb-3 hide-scrollbar",
		};

		return h.InfiniteScroll({
			child: h.div(
				{
					suggestions_id: `c-suggestions-${type}-${filter}`,
					class: "d-flex gap-3",
				},
				...args
			),
			callback: (entries, observer, marker) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					this.getSuggestions(
						marker,
						`c-suggestions-${type}-${filter}`,
						type,
						filter,
						attributes
					);
				});
			},
			managed: true,
		});
	}

	$$ojs = {
		beforeRouteChange: () => {
			this.cleanUp();
		},
	};

	cleanUp() {
		super.cleanUp();
		this.pageMap = null;
	}

	async getSuggestions(marker, holderId, type, filter, attributes) {
		this.pageMap[type]++;

		let page = this.pageMap[type];

		let spinner = h.Spinner({
			class: "p-3 my-auto mx-auto",
			parent: marker,
			resetParent: true,
		});

		let res = await api.get(
			`${routes.users}/suggest/${filter}/${type}`,
			{
				page,
			},
			{ silent: true }
		);

		if (res) {
			let users = res.data.suggestions.data;

			for (let u of users) {
				dom.all(`[suggestions-id='${holderId}']`)?.forEach((holder) => {
					let v = h.SuggestedUserView(u, attributes);
					let m = dom.get(`[ifs-marker='true']`, holder);
					m.classList.add("me-3");

					holder.insertBefore(v, m);
				});
			}

			if (!users?.length) {
				this.pageMap[type] = page - 1;

				if (page == 1) {
					broker.send($e.app.messages.noUserToSuggest, { type });
				}
			}
		}

		spinner.remove();
	}
}
